import { apiUrlV1, cancellableRequest } from 'src/services/api.js';

export const FeedbackService = {
  /**
   * @param {{
   *   form: {
   *     score: number,
   *     reaction: string,
   *     message?: string,
   *     feature: string,
   *     actions?: string[],
   *     action?: string,
   *   }
   * }} data
   */
  sendFeedback(data) {
    return cancellableRequest({
      method: 'post',
      url: `${apiUrlV1}/feedbacks/emotional_feedback`,
      data,
    });
  },

  /**
   * @param {number} id
   * @param {{form:{ message: string }}} data
   */
  updateFeedback(id, data) {
    return cancellableRequest({
      method: 'put',
      url: `${apiUrlV1}/feedbacks/emotional_feedback/${id}`,
      data,
    });
  },

  /**
   * @param featureAlias: string
   */
  trackViewFeedbackForm(featureAlias) {
    const params = { featureAlias };
    return cancellableRequest({
      method: 'post',
      url: `${apiUrlV1}/feedbacks/track_form`,
      params,
    });
  },
};
